import { useEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Skeleton, Stack } from '@mui/material';

am4core.useTheme(am4themes_animated);

const ChartTen = ({ data, name, className }) => {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        // Create chart instance
        let chart = am4core.create(name, am4charts.XYChart);
        chart.cursor = new am4charts.XYCursor();
        chart.scrollbarX = new am4core.Scrollbar();

        chart.events.on('ready', () => {
            setShowLoader(false);
        });

        // Sample Data
        chart.data = data['data'];
        let legend = data['legend'];

        // Create X-axis (CategoryAxis) for years
        let xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        xAxis.dataFields.category = "year";

        // Create Y-axis (ValueAxis)
        let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
        yAxis.extraMax = 0.15;
        yAxis.numberFormatter.numberFormat = "#'%'"; // Append '%' to the values

        // Create series
        let series1 = chart.series.push(new am4charts.LineSeries());
        series1.dataFields.valueY = "unconditional_transfer_divided_gpd";
        series1.dataFields.categoryX = "year"; // Use categoryX for year-based X-axis
        series1.tooltipText = "{unconditional_transfer_divided_gpd}";
        series1.tensionX = 1; // Straight line
        series1.stroke = am4core.color("#d42daa"); // Set line color
        series1.legendSettings.labelText = legend['unconditional_transfer_divided_gpd'];
        series1.strokeWidth = 2;
        series1.tooltip.getFillFromObject = false;
        series1.tooltip.background.fill = am4core.color("#d42daa");

        // Add bullets at data points
        let bullet1 = series1.bullets.push(new am4charts.CircleBullet());
        bullet1.circle.radius = 5;
        bullet1.circle.strokeWidth = 3;
        bullet1.tooltipText = "{unconditional_transfer_divided_gpd}";
        bullet1.fill = am4core.color("#d42daa"); // Set bullet color

        let label1 = bullet1.createChild(am4core.Label);
        label1.stroke = am4core.color("#000"); // Set label color
        label1.text = "{unconditional_transfer_divided_gpd}"; // Display the value of the bullet
        label1.horizontalCenter = "middle"; // Center horizontally
        label1.verticalCenter = "bottom"; // Center the label vertically above the bullet
        label1.dy = -10; // Adjust vertical position if needed
        label1.fontWeight = 'lighter';

        // Create series
        let series2 = chart.series.push(new am4charts.LineSeries());
        series2.dataFields.valueY = "unconditional_transfer_divided_public_revenue";
        series2.dataFields.categoryX = "year"; // Use categoryX for year-based X-axis
        series2.tooltipText = "{unconditional_transfer_divided_public_revenue}";
        series2.tensionX = 1; // Straight line
        series2.legendSettings.labelText = legend['unconditional_transfer_divided_public_revenue'];
        series2.strokeWidth = 2;

        // Add bullets at data points
        let bullet2 = series2.bullets.push(new am4charts.CircleBullet());
        bullet2.circle.radius = 5;
        bullet2.circle.strokeWidth = 3;
        bullet2.tooltipText = "{unconditional_transfer_divided_public_revenue}";

        let label2 = bullet2.createChild(am4core.Label);
        label2.stroke = am4core.color("#000"); // Set label color
        label2.text = "{unconditional_transfer_divided_public_revenue}"; // Display the value of the bullet
        label2.horizontalCenter = "middle"; // Center horizontally
        label2.verticalCenter = "bottom"; // Center the label vertically above the bullet
        label2.dy = -10; // Adjust vertical position if needed
        label2.fontWeight = 'lighter';

        // Add legend
        chart.legend = new am4charts.Legend();

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.menu.align = 'left';
        chart.exporting.menu.verticalAlign = 'top';

        // Clean up chart instance on unmount
        return () => {
            chart.dispose();
        };
    }, []);

    return (
        <>
            <div style={{ display: 'flex', gap: '20px' }}>
                {/* Chart container */}
                <div id={name} style={{width: showLoader ? '0' : '100%', height: showLoader ? '0' : '700px'}} className={className}></div>
            </div>

            {showLoader && (
                <Stack spacing={1}>
                <Skeleton variant='text' />
                    <Skeleton variant='rounded' width={'auto'} height={500} />
                </Stack>
            )}
        </>
    );
};

export default ChartTen;
